import { BsArrowUpRightCircle, BsClock, BsPencilSquare } from "react-icons/bs"; 
import { MdOutlinePets } from "react-icons/md";
import React from "react";
import { FaUser } from "react-icons/fa";
import CxIcon from "./CxIcon";

/**
 * CxIconVariant
 * Componente factoría para iconos compuestos reutilizables.
 * Creado por: Asistente de Programación - 2026-05-01
 */
const CxIconVariant = props => {
  const { 
    variant, 
    backIcon, 
    backColor, 
    backSize, 
    backMargin, 
    frontColor 
  } = props;

  const getVariantProps = () => {
    switch (variant) {
      case 'client-last':
        return {
          frontIcon: <BsClock />,
          frontSize: '12px',
          frontPos: { bottom: "-2px", right: "-2px" },
          frontShell: "circle",
          frontShellColor: "white",
          frontColor: frontColor || 'var(--ibs_color_black_dark)',
          vBackSize: '19px',
          vBackMargin: '2px 2px',
          vBackIcon: <FaUser />
        };
        
      case 'animal-go':
        return {
          frontIcon: <BsArrowUpRightCircle />,
          frontSize: '12px',
          frontPos: { bottom: "-1px", right: "-1px" },
          frontShell: "circle",
          frontShellColor: "white",
          frontColor: frontColor || 'var(--ibs_color_black_dark)',
          vBackSize: '22px',
          vBackMargin: '0px 2px',
          vBackIcon: <MdOutlinePets />
        };

      case 'client-go':
        return {
          frontIcon: <BsArrowUpRightCircle />,
          frontSize: '12px',
          frontPos: { bottom: "-2px", right: "-2px" },
          frontShell: "circle",
          frontShellColor: "white",
          frontColor: frontColor || 'var(--ibs_color_black_dark)',
          vBackSize: '19px',
          vBackMargin: '2px 2px',
          vBackIcon: <FaUser />
        };

      case 'client-edit':
        return {
          frontIcon: <BsPencilSquare />,
          frontSize: '12px',
          frontPos: { bottom: "-2px", right: "-2px" },
          frontShell: "circle",
          frontShellColor: "white",
          frontColor: frontColor || 'var(--ibs_color_black)',
          vBackSize: '19px',
          vBackMargin: '2px 2px',
          vBackIcon: <FaUser />
        };

      default:
        return {
          frontIcon: null,
          vBackSize: '19px',
          vBackMargin: '0px',
          vBackIcon: <FaUser />
        };
    }
  };

  const vProps = getVariantProps();

  return (
    <CxIcon 
      backIcon={backIcon || vProps.vBackIcon} 
      backSize={backSize || vProps.vBackSize} 
      backColor={backColor}
      backMargin={backMargin || vProps.vBackMargin} 
      frontIcon={vProps.frontIcon} 
      frontSize={vProps.frontSize} 
      frontColor={vProps.frontColor} 
      frontShell={vProps.frontShell} 
      frontShellColor={vProps.frontShellColor}
      frontPos={vProps.frontPos} 
    />
  );
};

export default CxIconVariant;
